import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  IconButton,
  Typography,
  Box,
  Divider,
  Chip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useSnackbar } from "./SnackbarProvider";

const useStyles = makeStyles((theme) => ({
  modalContent: {
    minHeight: "400px",
    padding: theme.spacing(2),
  },
  headerItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  dragHandle: {
    cursor: "grab",
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
    "&:active": {
      cursor: "grabbing",
    },
  },
  headerList: {
    maxHeight: "400px",
    overflow: "auto",
  },
  visibilityIcon: {
    marginRight: theme.spacing(1),
  },
  headerStats: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(1),
  },
}));

const CustomHeaderModal = ({
  open,
  onClose,
  headers,
  onSave,
  currentConfig,
}) => {
  const { showSnackbar } = useSnackbar();

  const classes = useStyles();
  const [headerConfig, setHeaderConfig] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  useEffect(() => {
    if (headers && headers.length > 0) {
      let initialConfig;

      if (currentConfig && currentConfig.length > 0) {
        // Use existing config
        initialConfig = currentConfig;
      } else {
        // Create new config from headers
        initialConfig = headers.map((header, index) => ({
          ...header,
          order: index,
          isVisible: header.isShow !== false,
        }));
      }

      setHeaderConfig(
        initialConfig.sort((a, b) => (a.order || 0) - (b.order || 0))
      );
    }
  }, [headers, currentConfig, open]);

  const handleVisibilityToggle = (index) => {
    const newConfig = [...headerConfig];
    newConfig[index] = {
      ...newConfig[index],
      isVisible: !newConfig[index].isVisible,
    };
    setHeaderConfig(newConfig);
  };

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();

    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      return;
    }

    const newConfig = [...headerConfig];
    const draggedItem = newConfig[draggedIndex];

    // Remove dragged item
    newConfig.splice(draggedIndex, 1);

    // Insert at new position
    newConfig.splice(dropIndex, 0, draggedItem);

    // Update order values
    const updatedConfig = newConfig.map((item, index) => ({
      ...item,
      order: index,
    }));

    setHeaderConfig(updatedConfig);
    setDraggedIndex(null);
  };

  const handleSave = () => {
    if (visibleCount == 0) {
      showSnackbar("select at least one row !", "error");
      return;
    }
    console.log("hii yash");
    const updatedHeaders = headerConfig.map((config) => ({
      ...config,
      isShow: config.isVisible,
    }));
    console.log("yashjain", updatedHeaders);

    onSave(updatedHeaders);
    console.log("yashjain", updatedHeaders);
    onClose();
  };

  const handleReset = () => {
    const resetConfig = headers.map((header, index) => ({
      ...header,
      order: index,
      isVisible: header.isShow !== false,
    }));
    setHeaderConfig(resetConfig);
  };

  const handleShowAll = () => {
    const newConfig = headerConfig.map((config) => ({
      ...config,
      isVisible: true,
    }));
    setHeaderConfig(newConfig);
  };

  const handleHideAll = () => {
    const newConfig = headerConfig.map((config) => ({
      ...config,
      isVisible: false,
    }));
    setHeaderConfig(newConfig);
  };

  const visibleCount = headerConfig.filter((config) => config.isVisible).length;
  const totalCount = headerConfig.length;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        style={{
          background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
          color: "white",
          padding: "16px",
        }}
      >
        <Typography variant="h5" style={{ fontWeight: "bold", color: "white" }}>
          Customize Table Headers
        </Typography>
        <Typography
          variant="body2"
          style={{ color: "rgba(255, 255, 255, 0.7)" }}
        >
          Configure which columns to display and their order
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.modalContent}>
        <Box className={classes.headerStats}>
          <Box>
            <Chip
              label={`${visibleCount} of ${totalCount} columns visible`}
              color="primary"
              variant="outlined"
              size="small"
            />
          </Box>
          <Box className={classes.actionButtons}>
            <Button
              size="small"
              onClick={handleShowAll}
              startIcon={<VisibilityIcon />}
              style={{
                background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
                color: "white",
                fontWeight: "bold",
                padding: "5px 10px",
              }}
            >
              Show All
            </Button>

            <Button
              size="small"
              onClick={handleHideAll}
              startIcon={<VisibilityOffIcon />}
              style={{
                background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
                color: "white",
                fontWeight: "bold",
                padding: "5px 10px",
              }}
            >
              Hide All
            </Button>

            <Button
              size="small"
              onClick={handleReset}
              variant="outlined"
              style={{
                border: "1px solid #1e243c",
                color: "#1e243c",
                fontWeight: "bold",
                padding: "5px 10px",
              }}
            >
              Reset
            </Button>
          </Box>
        </Box>

        <Divider />

        {/* Header Configuration List */}
        <List className={classes.headerList}>
          {headerConfig.map((config, index) => (
            <ListItem
              key={`${config.keyName}-${index}`}
              className={classes.headerItem}
              draggable
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, index)}
            >
              <IconButton
                className={classes.dragHandle}
                size="small"
                disableRipple
              >
                <DragHandleIcon />
              </IconButton>

              <Box className={classes.visibilityIcon}>
                {config.isVisible ? (
                  <VisibilityIcon color="primary" />
                ) : (
                  <VisibilityOffIcon color="disabled" />
                )}
              </Box>

              <ListItemText
                primary={config.name}
                secondary={`Key: ${config.keyName} | Order: ${index + 1}`}
                style={{
                  opacity: config.isVisible ? 1 : 0.5,
                }}
              />

              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  onChange={() => handleVisibilityToggle(index)}
                  checked={config.isVisible}
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>

        {headerConfig.length === 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="200px"
          >
            <Typography variant="body2" color="textSecondary">
              No headers available to configure
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions style={{ padding: "16px" }}>
        <Button
          onClick={onClose}
          style={{
            border: "1px solid #1e243c",
            color: "#1e243c",
            fontWeight: "bold",
            padding: "5px 10px",
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleSave}
          style={{
            background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
            color: "white",
            fontWeight: "bold",
            padding: "6px 10px",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomHeaderModal;
